var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallangerLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4655_315536)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M25.3692 50.0071C39.1783 50.0071 50.3728 38.8127 50.3728 25.0036C50.3728 11.1945 39.1783 0 25.3692 0C11.5602 0 0.365677 11.1945 0.365677 25.0036C0.365677 38.8127 11.5602 50.0071 25.3692 50.0071Z",
    fill: "url(#paint0_radial_4655_315536)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4404 5.21582C14.791 5.21582 6.15851 13.8483 6.15851 24.4906C6.15851 35.1329 14.791 43.7725 25.4404 43.7725C36.0898 43.7725 44.7152 35.14 44.7152 24.4906C44.7152 13.8412 36.0827 5.21582 25.4404 5.21582ZM25.4404 40.5684C16.5576 40.5684 9.36263 33.3734 9.36263 24.4906C9.36263 15.6078 16.5576 8.41994 25.4404 8.41994C34.3233 8.41994 41.5111 15.6149 41.5111 24.4906C41.5111 33.3663 34.3161 40.5684 25.4404 40.5684Z",
    fill: "url(#paint1_linear_4655_315536)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4409 6.96387C15.7571 6.96387 7.90411 14.8168 7.90411 24.4935C7.90411 34.1703 15.7571 42.0304 25.4409 42.0304C35.1248 42.0304 42.9706 34.1774 42.9706 24.4935C42.9706 14.8097 35.1177 6.96387 25.4409 6.96387ZM25.4409 40.5714C16.5581 40.5714 9.36313 33.3764 9.36313 24.4935C9.36313 15.6107 16.5581 8.42289 25.4409 8.42289C34.3238 8.42289 41.5116 15.6179 41.5116 24.4935C41.5116 33.3692 34.3166 40.5714 25.4409 40.5714Z",
    fill: "url(#paint2_linear_4655_315536)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2127 15.7967C10.2127 15.7967 16.2634 8.42289 25.4395 8.42289C34.6155 8.42289 40.8807 16.19 40.8807 16.19C40.8807 16.19 35.4094 6.96387 25.6898 6.96387C15.9701 6.96387 10.2127 15.7967 10.2127 15.7967Z",
    fill: "#2F3074"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3206 5.47559C22.3206 5.47559 15.5547 5.66154 9.76871 10.0672C9.76871 10.0672 9.32528 13.1068 8.11658 14.6803C6.90789 16.2537 1.12903 20.5736 1.12903 20.5736C1.12903 20.5736 2.58805 28.0117 8.62438 36.2366C8.62438 36.2366 10.7771 37.1234 13.2446 39.4264C13.2446 39.4264 5.55615 28.9701 8.43843 18.9787C11.3135 8.9944 22.3206 5.47559 22.3206 5.47559Z",
    fill: "url(#paint3_linear_4655_315536)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2123 12.6704L10.9418 10.3961C10.9418 10.3961 14.1673 7.5853 18.5659 6.48389C18.5659 6.48389 14.4892 7.57815 10.2123 12.6704Z",
    fill: "url(#paint4_linear_4655_315536)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90134 33.0062C7.90134 33.0062 3.88903 28.8437 2.97357 21.5772L8.03722 16.1846C8.03722 16.1846 4.41829 22.6643 7.90134 32.999V33.0062Z",
    fill: "url(#paint5_linear_4655_315536)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62265 18.5421C6.67987 18.256 3.8548 21.031 3.54011 22.0966C3.22542 23.1623 5.12787 28.6765 7.5095 31.7733C7.5095 31.7733 5.34958 24.7715 6.62265 18.5421Z",
    fill: "url(#paint6_linear_4655_315536)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1266 11.5753C11.1266 11.5753 11.1766 10.574 11.5414 10.1091C11.9061 9.64424 16.1616 7.56299 16.1616 7.56299C16.1616 7.56299 13.2436 9.22942 11.1266 11.5753Z",
    fill: "url(#paint7_linear_4655_315536)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50212 19.5294C2.50212 19.5294 4.36165 14.1796 9.66132 10.668C9.66132 10.668 9.13207 13.3571 8.37396 14.6803C7.60869 16.0034 2.50212 19.5294 2.50212 19.5294Z",
    fill: "url(#paint8_linear_4655_315536)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79519 19.2086C2.79519 19.2086 4.0325 16.6982 5.04809 15.5896C6.06368 14.4811 8.57405 13.9375 8.57405 13.9375C8.57405 13.9375 8.01619 15.0461 6.15666 16.5766C4.29712 18.1 2.78804 19.2157 2.78804 19.2157L2.79519 19.2086Z",
    fill: "#89FF15"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32427 23.6286C3.18123 22.9134 6.47832 19.3517 6.47832 19.3517L7.90158 16.4766L2.97382 21.5831L3.33142 23.6358L3.32427 23.6286Z",
    fill: "#2F3074"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40846 25.1509C6.40846 25.1509 5.53591 25.8303 5.44293 26.9603C5.34996 28.0975 7.52418 31.7737 7.52418 31.7737C7.52418 31.7737 6.27972 28.6697 6.41561 25.1509H6.40846Z",
    fill: "#89FF15"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7699 10.0657C9.7699 10.0657 10.478 10.08 11.6294 9.69377C12.7809 9.30756 13.9968 7.6912 17.1866 6.79004C17.1866 6.79004 13.3388 7.13334 9.7699 10.0657Z",
    fill: "#92A495"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12903 20.5755C1.12903 20.5755 2.33772 21.0189 3.41768 20.7972C4.49764 20.5755 7.22258 17.0566 7.22258 17.0566C7.22258 17.0566 4.19726 18.3726 1.12903 20.5755Z",
    fill: "#34543A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6085 5.47737C28.6085 5.47737 35.3743 5.66332 41.1604 10.069C41.1604 10.069 41.6038 13.1086 42.8125 14.6821C44.0212 16.2555 49.8 20.5753 49.8 20.5753C49.8 20.5753 48.341 28.0135 42.3047 36.2383C42.3047 36.2383 40.1519 37.1252 37.6845 39.4282C37.6845 39.4282 45.3729 28.9719 42.4906 18.9804C39.6084 8.99618 28.6085 5.47021 28.6085 5.47021V5.47737Z",
    fill: "url(#paint9_linear_4655_315536)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7172 12.6699L39.9876 10.3956C39.9876 10.3956 36.7621 7.58481 32.3636 6.4834C32.3636 6.4834 36.4402 7.57766 40.7172 12.6699Z",
    fill: "url(#paint10_linear_4655_315536)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0273 33.0057C43.0273 33.0057 47.0396 28.8432 47.955 21.5767L42.8914 16.1841C42.8914 16.1841 46.5103 22.6638 43.0273 32.9986V33.0057Z",
    fill: "url(#paint11_linear_4655_315536)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3083 18.546C44.2511 18.2599 47.0761 21.0349 47.3908 22.1005C47.7055 23.1662 45.8031 28.6804 43.4214 31.7773C43.4214 31.7773 45.5813 24.7754 44.3083 18.546Z",
    fill: "url(#paint12_linear_4655_315536)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8013 11.5792C39.8013 11.5792 39.7513 10.5779 39.3865 10.113C39.0218 9.64814 34.7663 7.56689 34.7663 7.56689C34.7663 7.56689 37.6843 9.23332 39.8013 11.5792Z",
    fill: "url(#paint13_linear_4655_315536)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4345 19.5284C48.4345 19.5284 46.575 14.1786 41.2753 10.667C41.2753 10.667 41.8046 13.3562 42.5627 14.6793C43.3208 16.0024 48.4345 19.5284 48.4345 19.5284Z",
    fill: "url(#paint14_linear_4655_315536)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1331 19.2076C48.1331 19.2076 46.8958 16.6972 45.8802 15.5886C44.8646 14.4801 42.3543 13.9365 42.3543 13.9365C42.3543 13.9365 42.9121 15.0451 44.7717 16.5756C46.6312 18.099 48.1403 19.2147 48.1403 19.2147L48.1331 19.2076Z",
    fill: "#89FF15"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6053 23.6281C47.7484 22.9129 44.4513 19.3512 44.4513 19.3512L43.028 16.4761L47.9558 21.5826L47.5982 23.6353L47.6053 23.6281Z",
    fill: "#2F3074"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5301 25.1499C44.5301 25.1499 45.4026 25.8293 45.4956 26.9594C45.5886 28.0965 43.4144 31.7727 43.4144 31.7727C43.4144 31.7727 44.6588 28.6687 44.5229 25.1499H44.5301Z",
    fill: "#89FF15"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1583 10.0652C41.1583 10.0652 40.4503 10.0795 39.2988 9.69328C38.1473 9.30707 36.9315 7.69071 33.7417 6.78955C33.7417 6.78955 37.5895 7.13285 41.1583 10.0652Z",
    fill: "#92A495"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8 20.5745C49.8 20.5745 48.5913 21.0179 47.5114 20.7962C46.4314 20.5745 43.7065 17.0557 43.7065 17.0557C43.7065 17.0557 46.7318 18.3716 49.8 20.5745Z",
    fill: "#34543A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.678 11.0609C11.678 11.0609 18.0004 8.04276 22.0485 7.18451C26.0965 6.32627 31.4105 7.55642 31.4105 7.55642C31.4105 7.55642 28.4138 4.76712 22.0842 5.54669C15.7547 6.32627 11.678 11.0538 11.678 11.0538V11.0609Z",
    fill: "#34543A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15853 20.5073C7.57207 20.4429 7.00705 21.6874 7.57922 22.5099C8.14423 23.3252 9.49597 20.6503 8.15853 20.5073Z",
    fill: "#0E1B20"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43532 21.4458C7.51399 22.1109 8.35078 21.9893 8.6011 21.5888C8.85858 21.1812 8.69408 20.4087 8.079 20.5089C7.45677 20.6161 7.43532 21.4458 7.43532 21.4458Z",
    fill: "#612FBE"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37878 22.047C7.48606 21.6178 8.06538 22.0041 8.36577 21.9683C8.66615 21.9325 8.27994 22.6763 7.91519 22.6477C7.55043 22.6191 7.37878 22.0398 7.37878 22.0398V22.047Z",
    fill: "#436148"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5746 6.95846C23.5746 6.95846 24.2254 6.5794 25.9705 6.47927C27.7156 6.37915 30.319 7.64506 30.319 7.64506C30.319 7.64506 27.2722 6.68668 23.5674 6.95846H23.5746Z",
    fill: "#55705A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5983 37.1228L41.0527 32.4668C41.0527 32.4668 39.4435 36.1716 37.5983 37.1228Z",
    fill: "#55705A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5466 38.5697L15.1833 38.2622C15.1833 38.2622 16.5421 45.1496 16.6351 45.6932C16.7353 46.2367 25.5394 48.0391 25.5394 48.0391C25.5394 48.0391 34.3508 46.2439 34.4437 45.6932C34.5439 45.1496 35.8956 38.2622 35.8956 38.2622L25.5323 38.5697H25.5466Z",
    fill: "url(#paint15_linear_4655_315536)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0279 39.9564C17.0279 39.9564 21.7196 39.7275 25.5388 39.7275H34.343L33.5992 45.0272C33.5992 45.0272 27.3197 47.3802 25.5388 47.3802C23.758 47.3802 17.5571 45.2847 17.5571 45.2847L17.0207 39.9564H17.0279Z",
    fill: "url(#paint16_linear_4655_315536)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5649 40.5466C17.5649 40.5466 22.5713 40.189 25.5466 40.189H33.9646C33.9646 40.189 33.2064 44.8092 33.0563 45.131C32.9132 45.4529 27.2559 47.0335 25.5466 47.0335C23.8373 47.0335 17.9082 45.131 17.9082 45.131L17.5649 40.5466Z",
    fill: "#0E1B20"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1902 38.2622C15.1902 38.2622 17.9152 39.4638 25.5464 39.7355C33.1776 40.0073 35.8454 38.4768 35.8454 38.4768L15.1902 38.2622Z",
    fill: "#436148"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5465 47.0304C25.5036 46.9302 27.6278 47.2378 28.1284 47.0304C28.6291 46.8229 32.2122 45.8574 32.2122 45.8574C32.2122 45.8574 26.934 47.1591 25.5394 47.0304H25.5465Z",
    fill: "#55705A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5486 39.6939C27.5486 39.6939 29.4295 39.2576 32.2117 39.4436C32.2117 39.4436 29.4582 39.9514 27.5486 39.6939Z",
    fill: "#55705A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9433 41.1732C38.3906 40.3007 44.7345 40.7584 44.7345 40.7584C44.7345 40.7584 48.9399 35.0296 49.2117 33.0557L43.4972 33.3775C43.4972 33.3775 40.6149 36.7247 39.0128 37.9977C37.4108 39.2708 34.9433 41.1732 34.9433 41.1732Z",
    fill: "url(#paint17_linear_4655_315536)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6554 39.5902C38.6554 39.5902 42.9467 35.4778 43.9837 34.8699C45.0136 34.262 48.0246 34.0688 48.0246 34.0688C48.0246 34.0688 45.4427 38.3672 44.0481 39.1253C42.6534 39.8835 38.6554 39.5831 38.6554 39.5831V39.5902Z",
    fill: "url(#paint18_linear_4655_315536)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2144 39.1796C39.2144 39.1796 43.3983 35.8968 44.4354 35.4319C45.4724 34.967 47.3677 34.5308 47.3677 34.5308C47.3677 34.5308 45.2149 37.9494 43.5914 38.7648C41.9679 39.5801 39.2144 39.1724 39.2144 39.1724V39.1796Z",
    fill: "url(#paint19_linear_4655_315536)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4161 31.4139L49.2139 33.0589L43.4994 33.3807C43.4994 33.3807 44.4363 32.8801 44.6223 32.737C44.8154 32.594 45.409 31.4067 45.409 31.4067L45.4161 31.4139Z",
    fill: "#34543A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4711 39.2197C39.4711 39.2197 40.501 39.6059 41.7526 39.6059C43.0042 39.6059 43.8696 39.2197 43.8696 39.2197C43.8696 39.2197 43.1258 39.1338 42.2032 39.1911C41.2805 39.2483 39.4711 39.2197 39.4711 39.2197Z",
    fill: "#55705A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2697 33.3379C44.2697 33.3379 45.414 32.6084 46.2508 32.6084C47.0876 32.6084 48.2749 33.059 48.2749 33.059L44.2697 33.3379Z",
    fill: "#55705A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 41.1732C12.5531 40.3007 6.20926 40.7584 6.20926 40.7584C6.20926 40.7584 2.00385 35.0296 1.73207 33.0557L7.44656 33.3775C7.44656 33.3775 10.3288 36.7247 11.9309 37.9977C13.533 39.2708 16.0004 41.1732 16.0004 41.1732Z",
    fill: "url(#paint20_linear_4655_315536)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2886 39.5902C12.2886 39.5902 7.99733 35.4778 6.96028 34.8699C5.93039 34.262 2.91937 34.0688 2.91937 34.0688C2.91937 34.0688 5.50126 38.3672 6.89591 39.1253C8.29056 39.8835 12.2886 39.5831 12.2886 39.5831V39.5902Z",
    fill: "url(#paint21_linear_4655_315536)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7394 39.1791C11.7394 39.1791 7.55543 35.8963 6.51839 35.4314C5.48134 34.9665 3.58604 34.5303 3.58604 34.5303C3.58604 34.5303 5.73881 37.949 7.36233 38.7643C8.98584 39.5796 11.7394 39.172 11.7394 39.172V39.1791Z",
    fill: "url(#paint22_linear_4655_315536)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53678 31.4139L1.73904 33.0589L7.45353 33.3807C7.45353 33.3807 6.51662 32.8801 6.33066 32.737C6.13756 32.594 5.54394 31.4067 5.54394 31.4067L5.53678 31.4139Z",
    fill: "#34543A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4805 39.2197C11.4805 39.2197 10.4506 39.6059 9.19898 39.6059C7.94737 39.6059 7.08197 39.2197 7.08197 39.2197C7.08197 39.2197 7.82578 39.1338 8.7484 39.1911C9.67101 39.2483 11.4805 39.2197 11.4805 39.2197Z",
    fill: "#55705A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67951 33.3379C6.67951 33.3379 5.53518 32.6084 4.69839 32.6084C3.8616 32.6084 2.67436 33.059 2.67436 33.059L6.67951 33.3379Z",
    fill: "#55705A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1327 7.50078C14.1327 7.50078 16.6645 4.2466 22.7652 1.16406L22.0858 5.54827C22.0858 5.54827 17.4584 5.9917 14.1327 7.50078Z",
    fill: "url(#paint23_linear_4655_315536)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7587 1.16633L22.8946 5.46472L22.0864 5.54339C22.0864 5.54339 21.5214 3.52651 22.7659 1.15918L22.7587 1.16633Z",
    fill: "#0E1B20"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7191 6.8475C14.7191 6.8475 19.0604 5.35987 19.9973 4.69473C20.9343 4.02959 22.6436 1.40479 22.6436 1.40479C22.6436 1.40479 17.6515 3.77927 14.7191 6.8475Z",
    fill: "#34543A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7489 7.50078C36.7489 7.50078 34.2171 4.2466 28.1164 1.16406L28.7958 5.54827C28.7958 5.54827 33.4232 5.9917 36.7489 7.50078Z",
    fill: "url(#paint24_linear_4655_315536)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1133 1.16633L27.9774 5.46472L28.7856 5.54339C28.7856 5.54339 29.3506 3.52651 28.1061 1.15918L28.1133 1.16633Z",
    fill: "#0E1B20"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M36.161 6.8475C36.161 6.8475 31.8197 5.35987 30.8828 4.69473C29.9458 4.02959 28.2365 1.40479 28.2365 1.40479C28.2365 1.40479 33.2286 3.77927 36.161 6.8475Z",
    fill: "#34543A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4711 39.2183C39.4711 39.2183 41.5023 37.3731 42.5035 36.9941C43.5048 36.615 45.4216 37.1228 45.4216 37.1228C45.4216 37.1228 44.2343 38.5604 42.8254 39.0109C41.4093 39.4615 39.4782 39.2255 39.4782 39.2255L39.4711 39.2183Z",
    fill: "#89FF15"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30818 36.9194C5.30818 36.9194 7.62544 37.0267 9.16313 37.7133C10.7008 38.3999 11.18 39.1723 11.18 39.1723C11.18 39.1723 8.98433 39.1938 7.89722 39.0007C6.81011 38.8076 5.30103 36.9194 5.30103 36.9194H5.30818Z",
    fill: "#89FF15"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0667 3.89258C30.0667 3.89258 31.2826 3.92834 32.5914 5.51609C32.5914 5.51609 31.0108 5.10127 30.0667 3.89258Z",
    fill: "#55705A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6063 4.12028C20.6063 4.12028 21.1641 3.11899 21.486 2.77569C21.8078 2.43239 22.144 2.13916 22.144 2.13916C22.144 2.13916 21.2643 3.86996 20.6063 4.12028Z",
    fill: "#55705A"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M47.7121 26.3989C47.0899 28.7018 45.6022 30.3039 44.3792 29.9749C43.1562 29.6459 42.6699 27.5146 43.285 25.2116C43.9072 22.9087 45.3948 21.3066 46.6178 21.6356C47.8408 21.9646 48.3272 24.0959 47.7121 26.3989Z",
    fill: "url(#paint25_radial_4655_315536)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M8.05611 40.6358C5.78176 39.9135 4.25122 38.3472 4.63743 37.1456C5.02364 35.9441 7.17641 35.5507 9.45076 36.2731C11.7251 36.9955 13.2557 38.5617 12.8694 39.7633C12.4832 40.972 10.3305 41.3582 8.05611 40.6358Z",
    fill: "url(#paint26_radial_4655_315536)"
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4278 20.6079L23.3876 33.3272H21.0869L17.0279 20.6079H19.4969L21.4235 27.005L22.3027 30.297L23.2379 26.9863L25.1458 20.6079H27.4278Z",
    fill: "url(#paint27_linear_4655_315536)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6922 33.3272H29.4476V20.6079H31.6922V33.3272Z",
    fill: "url(#paint28_linear_4655_315536)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4655_315536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3692 25.0036) scale(25.0036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "transparent",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#00F98B",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#00B866",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#008047",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#00522D",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "transparent",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4655_315536",
    x1: 25.4404,
    y1: 43.7725,
    x2: 25.4404,
    y2: 5.21582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24382F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4655_315536",
    x1: 25.4409,
    y1: 42.0304,
    x2: 25.4409,
    y2: 6.96387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#405149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4655_315536",
    x1: 11.7212,
    y1: 39.4264,
    x2: 11.7212,
    y2: 5.47559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24382F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4655_315536",
    x1: 14.3891,
    y1: 12.6704,
    x2: 14.3891,
    y2: 6.47673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#405149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4655_315536",
    x1: 5.5054,
    y1: 33.0062,
    x2: 5.5054,
    y2: 16.1917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#405149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4655_315536",
    x1: 5.51408,
    y1: 31.7733,
    x2: 5.51408,
    y2: 18.5206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27FF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4655_315536",
    x1: 12.9003,
    y1: 12.0688,
    x2: 14.3021,
    y2: 7.04089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27FF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DFFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4655_315536",
    x1: 6.965,
    y1: 18.2921,
    x2: 5.19129,
    y2: 11.9124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27FF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DFFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4655_315536",
    x1: 39.2007,
    y1: 39.4282,
    x2: 39.2007,
    y2: 5.47737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24382F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4655_315536",
    x1: 36.5404,
    y1: 12.6699,
    x2: 36.5404,
    y2: 6.47625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#405149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4655_315536",
    x1: 45.4232,
    y1: 33.0057,
    x2: 45.4232,
    y2: 16.1912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#405149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4655_315536",
    x1: 45.4168,
    y1: 31.7773,
    x2: 45.4168,
    y2: 18.5245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27FF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4655_315536",
    x1: 38.0276,
    y1: 0.00717411,
    x2: 36.6258,
    y2: 0.00717411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27FF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DFFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4655_315536",
    x1: 43.9645,
    y1: 18.2911,
    x2: 45.7382,
    y2: 11.9114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27FF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DFFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4655_315536",
    x1: 25.5466,
    y1: 48.0319,
    x2: 25.5466,
    y2: 38.2622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24382F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4655_315536",
    x1: 25.689,
    y1: 47.3874,
    x2: 25.689,
    y2: 39.7347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#405149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4655_315536",
    x1: 41.7407,
    y1: 41.6701,
    x2: 42.417,
    y2: 32.5476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24382F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4655_315536",
    x1: 43.1123,
    y1: 39.9118,
    x2: 43.5702,
    y2: 33.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#405149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4655_315536",
    x1: 43.1018,
    y1: 39.4849,
    x2: 43.4904,
    y2: 34.2425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27FF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4655_315536",
    x1: 9.23875,
    y1: 41.6124,
    x2: 8.56243,
    y2: 32.4899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24382F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4655_315536",
    x1: 7.8674,
    y1: 39.8541,
    x2: 7.40948,
    y2: 33.6774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#405149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4655_315536",
    x1: 7.88766,
    y1: 39.4262,
    x2: 7.49901,
    y2: 34.1838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27FF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4655_315536",
    x1: 19.0176,
    y1: 6.39936,
    x2: 17.9376,
    y2: 2.50865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24382F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4655_315536",
    x1: 31.8569,
    y1: 6.39936,
    x2: 32.944,
    y2: 2.50865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24382F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_4655_315536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4784 25.8874) rotate(15.05) scale(2.28866 4.30267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00F92C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00B820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#008016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00520E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_4655_315536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.53397 38.6911) rotate(107.64) scale(2.28866 4.30268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00F92C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00B820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#008016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00520E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4655_315536",
    x1: 24.3601,
    y1: 20.6079,
    x2: 24.3601,
    y2: 33.3272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1FFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11EADF",
    stopOpacity: 0.72
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4655_315536",
    x1: 24.3601,
    y1: 20.6079,
    x2: 24.3601,
    y2: 33.3272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1FFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11EADF",
    stopOpacity: 0.72
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4655_315536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.361023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallangerLeague);
export default __webpack_public_path__ + "static/media/challanger-league.fc6fe921d15ec5e9ffd089da267f5843.svg";
export { ForwardRef as ReactComponent };